import { handleActions } from 'redux-actions'
import * as type from './type'
import * as names from '../const'
import { LOCATION_CHANGE } from 'connected-react-router'

export const initialState = {
    fetching: {
        [names.FILE_TYPE_SCAN_FILE]: false,
        [names.FILE_TYPE_X_RAY]: false,
        [names.FILE_TYPE_IMPLANT_SCAN_FILE]: false,
        [names.FILE_TYPE_TREATMENT_PLAN]: false,
        [names.FILE_TYPE_TREATMENT_PLAN_EXTERNAL]: false,
        [names.FILE_TYPE_PRODUCTION]: false,
        [names.FILE_TYPE_IMPLANT_TREATMENT_PLAN]: false,
        [names.FILE_TYPE_CONFORMITY_DECLARATION]: false,
        [names.FILE_TYPE_OTHER_FILES]: false,
    },
    error: null,
    deleteFileConfirmationModalOpen: false,
    visualizationRequested: false,
}


export default handleActions({
    [LOCATION_CHANGE]: (state, action) => {
        return {
            ...initialState,
        }
    },
    [type.TRIGGER_VISUALIZATION_REQUEST]: (state, action) => {
        return {
            ...state,
            visualizationRequested: true,
        }
    },
    [type.UPLOAD_CUSTOMER_FILE_REQUEST]: (state, action) => {
        const { fileType } = action.payload
        return {
            ...state,
            fetching: {
                ...state.fetching,
                [fileType]: true,
            },
            error: null,
        }
    },
    [type.UPLOAD_CUSTOMER_FILE_SUCCESS]: (state, action) => {
        const { fileType } = action.payload
        return {
            ...state,
            fetching: {
                ...state.fetching,
                [fileType]: false,
            },
        }
    },
    [type.UPLOAD_CUSTOMER_FILE_ERROR]: (state, action) => {
        const { fileType, error } = action.payload

        return {
            ...state,
            fetching: {
                ...state.fetching,
                [fileType]: false,
            },
            error,
        }
    },
    [type.SET_DELETE_FLAG_REQUEST]: (state, action) => {
        const { fileType } = action.payload
        return {
            ...state,
            fetching: {
                ...state.fetching,
                [fileType]: true,
            },
            error: null,
        }
    },
    [type.SET_DELETE_FLAG_SUCCESS]: (state, action) => {
        const { fileType } = action.payload
        return {
            ...state,
            fetching: {
                ...state.fetching,
                [fileType]: false,
            },
        }
    },
    [type.SET_DELETE_FLAG_ERROR]: (state, action) => {
        const { fileType, error } = action.payload
        return {
            ...state,
            error,
            fetching: {
                ...state.fetching,
                [fileType]: false,
            },
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/customer/state/file-upload/reducer.js